import React, { useContext, useEffect, useState } from "react";
import SlidingDiv from "../Components/SlidingDiv";
import magnifying from '../images/Groups.svg'
import logo from '../images/Groups.png'
import HeroSection from '../images/Image.png'
import porp1Img from '../images/Image (1).png'
import viewMoreImg from '../images/Groups (1).svg'
import prop2Img from '../images/Image (2).png'
import footprop1 from '../images/Frame.png'
import footprop2 from '../images/Frame (1).png'
import footprop3 from '../images/Frame (2).png'
import { TypeAnimation } from 'react-type-animation';
import { useNavigate } from 'react-router-dom';


function Home() {
    const navigator = useNavigate()


    return (
        <div>
            <div className="HeroBackGround">

            </div>

            <div className="input-box-container">

                <div className="input-box-icon">
                    {/* Replace this with your actual SVG */}
                    <img src={magnifying} alt="" />
                </div>

                <input
                    type="text"
                    className="input-box-field gr"
                />
            </div>

            <div className="heroSection">
                <div className="HS1">
                    <div className="HS1img gr">
                        <img src={logo} alt="" />
                        REALTY
                    </div>

                    <div className="HS1txt">
                        <div className="scroll-content gr">
                            <span>SEARCH</span>
                            <span>PROPERTIES</span>
                            <span>AGENTS</span>
                            <span>STORIES</span>

                            {/* Repeat for smooth infinite scroll */}
                            <span>SEARCH</span>
                            <span>PROPERTIES</span>
                            <span>AGENTS</span>
                            <span>STORIES</span>
                        </div>
                    </div>
                </div>

                <div className="HS2">
                    <div className="hs2img gr">
                        <img src={HeroSection} alt="" />
                        <div>
                            <TypeAnimation
                                sequence={[
                                    `11 bedroom luxury House in New Delhi,\nTerritory of Delhi`, 3000,
                                    '',
                                ]}
                                wrapper="span"
                                cursor={true}
                                repeat={Infinity}
                                speed={50}
                            />

                        </div>
                    </div>
                    <div className="mainHeadlineHs2 gel">
                        For exceptional homes and life, there is Bask Realty.
                    </div>

                    <div className="prelineHS2 gr">
                        Dedicated to bringing a fresh outlook to the luxury real estate industry, Bask Realty offers exceptional experiences for those seeking beyond-the-ordinary in luxury dwellings.
                    </div>
                </div>
            </div>


            <div className="propList">

                <div className="prop1" onClick={()=>navigator('/property')}>
                    <div className="propimg">
                        <SlidingDiv direction="left">
                            <img src={porp1Img} alt="" />
                        </SlidingDiv>
                    </div>

                    <div className="propdescr">
                        <SlidingDiv direction="right">

                            <div className="propNum gr">
                                01
                            </div>
                            <div className="propName gm">
                                Elegant Lakeview Home on Upper Tyner
                            </div>
                            <div className="propdescreption gr">
                                Located on Lake Tahoe's stunning north shore in tax-friendly
                                Nevada, discover this elegant lakeview mountain retreat.
                                Southern exposure floods the space with natural light,
                                illuminating the soaring beams, Waterford Crystal chandelier, and
                            </div>
                            <div className="propViewMore gr">
                                VIEW DETAILS
                                <img src={viewMoreImg} alt="" />
                            </div>
                        </SlidingDiv>
                    </div>
                </div>

                <div className="prop1" onClick={()=> navigator('/property')}>
                    <div className="propdescr">
                        <SlidingDiv direction="left">

                            <div className="propNum gr">
                                02
                            </div>
                            <div className="propName gm">
                                Elegant Lakeview Home on Upper Tyner
                            </div>
                            <div className="propdescreption gr">
                                Located on Lake Tahoe's stunning north shore in tax-friendly
                                Nevada, discover this elegant lakeview mountain retreat.
                                Southern exposure floods the space with natural light,
                                illuminating the soaring beams, Waterford Crystal chandelier, and
                            </div>
                            <div className="propViewMore gr">
                                VIEW DETAILS
                                <img src={viewMoreImg} alt="" />
                            </div>
                        </SlidingDiv>
                    </div>

                    <div className="propimg">
                        <SlidingDiv direction="right">
                            <img src={prop2Img} alt="" />
                        </SlidingDiv>
                    </div>


                </div>

            </div>

            <div className="FinalSectionHP">
                <div className="headTitle gr">
                    CONTINUE YOUR SEARCH
                </div>

                <div className="propListFSH">
                    <div className="prop1FSH" onClick={()=>navigator('/property')}>
                        <div className="imgPropFSH">
                            <img src={footprop1} alt="" />
                        </div>

                        <div className="textFSH gel">
                            2170 Highway 28 <br />
                            Carson City, Nevada, 89703
                            United States
                        </div>
                    </div>

                    <div className="prop1FSH" onClick={()=>navigator('/property')}>
                        <div className="imgPropFSH">
                            <img src={footprop2} alt="" />
                        </div>

                        <div className="textFSH gel">
                            2170 Highway 28<br />
                            Carson City, Nevada, 89703
                            United States
                        </div>
                    </div>


                    <div className="prop1FSH" onClick={()=>navigator('/property')}>
                        <div className="imgPropFSH">
                            <img src={footprop3} alt="" />
                        </div>

                        <div className="textFSH gel">
                            2170 Highway 28<br />
                            Carson City, Nevada, 89703
                            United States
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );
}

export default Home;
